
import axios from "axios"
import { jwtDecode } from 'jwt-decode';
import { axiosGet, axiosPost } from './helpers'

const verifyauthCheck = async () => {
	var resp = await axiosGet(`${process.env.REACT_APP_API_HOSTNAME}/admin/verify-auth`);
	return resp
}

// login API
const validateUser = async (userData) => {
	const response = await axios.post(`${process.env.REACT_APP_API_HOSTNAME}/users/validate-user`, userData, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
	return response
}

const getDashboardStats = async () => {
	var resp = await axiosGet(`${process.env.REACT_APP_API_HOSTNAME}/admin/dashboard`);
	return resp
}

const getUsersList = async (pageNumber) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/users-list`, pageNumber);
	return resp
}

const getSubscriptionRevenueList = async (pageNumber) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/subscription-revenue-list`,pageNumber);
	return resp
}

const getSubscriptionPlanList = async (pageNumber) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/subscription-plan-list`,pageNumber);
	return resp
}

const getExpertTipsList = async (pageNumber) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/expert-tips-list`,pageNumber);
	return resp
}

const getWinningResultsList = async (pageNumber) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/winning-results-list`,pageNumber);
	return resp
}

const getVouchersList = async (pageNumber) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/vouchers-list`,pageNumber);
	return resp
}

const updateProfile = async (file) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/update-admin-profile`, file, 1);
	return resp
}

const updateProfileInfo = async (file) => {
	var resp = await axiosPost(`${process.env.REACT_APP_API_HOSTNAME}/admin/update-admin`, file);
	return resp
}

const getRunningUnitsList = async (pageNumber) => {
	var resp = await axiosGet(`${process.env.REACT_APP_API_HOSTNAME}/admin/get-all-running-units`, pageNumber);
	return resp
}

export {
  validateUser,
	verifyauthCheck,
	getDashboardStats,
	getUsersList,
	getSubscriptionRevenueList,
	getSubscriptionPlanList,
	getExpertTipsList,
	getWinningResultsList,
	getVouchersList,
	updateProfile,
	updateProfileInfo,
	getRunningUnitsList
}